import React, { useContext, useEffect, useState } from 'react'
import Application from '../../../StateContext/Application';

const GRN = () => {
    const statecalls = useContext(Application);
    const { getGrnData, GetVendors } = statecalls;
    const [vendor, setVendor] = useState([])
    const [formData, setFormData] = useState({
        grnno: '',
        grndate: '',
        vendor: '',
        POList: '',
        Invoiceno: '',
        Transporttype: '',
        Transportvehicleno: '',
        TransportContactn0: '',
        transportContact: '',
        LrDetails: '',
    });
    const getVendors = async () => {
        let data = await GetVendors()
        console.log("Fetched Vendors:", data);
        setVendor(data)
    }
    useEffect(() => {
        getVendors();
    }, []);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const submit = async (e) => {
        e.preventDefault();
        const res = await getGrnData("insert", formData);
        console.log("Insert Result:", res);
        alert(res.message || "Something went wrong");
    };

    return (
        <div style={{ display: "grid", justifyContent: "center" }}>
            <div className="card-body my-3" style={{ width: "75vw" }}>
                <form onSubmit={submit} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
                    <div style={{ display: 'grid', justifyContent: 'center', padding: '2rem' }}>
                        <h5>Add GRN</h5>
                        <div>
                            <div className='my-3' style={{ display: 'flex' }}>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label className='form-label'>GRN No</label>
                                    <input className='form-control' placeholder='Enter GRN no' name='grnno' type='text' onChange={handleChange} />
                                </div>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label className='form-label'>Date</label>
                                    <input className='form-control' name='grndate' type='date' onChange={handleChange} />
                                </div>
                            </div>
                            <div className='my-3' style={{ display: 'flex' }}>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label className='form-label'>Select Vendor</label>
                                    <select style={{ boxShadow: '0px 0px 4px' }} class="form-select" aria-label="Default select example" name="vendor" value={formData.Vendor_Company_Name} onChange={handleChange} aria-required>
                                        <option selected disabled >Select Vendor</option>
                                        {vendor && vendor.map((e) => (
                                            <option className="form-control " name="Vendor_Company_Name" value={e.Bidder_CompanyName} id={e.Bidder_CompanyName}>{e.Bidder_CompanyName}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label className='form-label'>PO (Purchase order List)</label>
                                    <input className='form-control' placeholder='Enter purchase Order List Here' name='POList' onChange={handleChange} />
                                </div>
                            </div>
                            <div className='my-3' style={{ display: 'flex' }}>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label className='form-label'>Invoice No. /Challen No.</label>
                                    <input className='form-control' type='text' name='Invoiceno' placeholder='Enter Invoice No. /Challen No. Here' onChange={handleChange} />
                                </div>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label className='form-label'>Transport Type</label>
                                    <input className='form-control' name='Transporttype' type='text' placeholder='Enter Transport Type Here' onChange={handleChange} />
                                </div>
                            </div>
                            <div className='my-3' style={{ display: 'flex' }}>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label>Transport Vehicle No.</label>
                                    <input className='form-control' type='text' name='Transportvehicleno' placeholder='Enter Transport Vehicle No. Here' onChange={handleChange} />
                                </div>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label>Transport Contact No.</label>
                                    <input className='form-control' type='text' name='TransportContactn0' placeholder='Enter Transport Contact No. Here' onChange={handleChange} />
                                </div>
                            </div>
                            <div className='my-3' style={{ display: 'flex' }}>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label className='form-label'>Transport Contact Person</label>
                                    <input className='form-control' type='text' name='transportContact' placeholder='Enter Transport Contact Person Here' onChange={handleChange} />
                                </div>
                                <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                    <label className='form-label'>LR Details</label>
                                    <input className='form-control' type='text' name='LrDetails' placeholder='Enter LR Details Here' onChange={handleChange} />
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <button style={{ backgroundColor: 'red', width: '6rem', height: '2rem', color: 'white', border: 'none', borderRadius: '5px' }} type="submit"> Add GRN</button>
                        </div>
                    </div>
                </form>
            </div>
            <div className="card-body my-3" style={{ width: "75vw" }}>
                <form style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
                    <div style={{ display: 'grid', justifyContent: 'center', padding: '2rem' }}>
                        <div className='my-3' style={{ display: 'flex' }}>
                            <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                <label className='form-label'>Product Name</label>
                                <input className='form-control' type='text' placeholder='Product Name' />
                            </div>
                            <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                <label className='form-label'>Item Code</label>
                                <input className='form-control' type='text' placeholder='Item Code' />
                            </div>
                        </div>
                        <div className='my-3' style={{ display: 'flex' }}>
                            <div className='mx-3 my-1' style={{ width: '29rem' }}>
                                <label className='form-label'>Received Qty</label>
                                <input className='form-control' type='text' placeholder='Received Qty' />
                            </div>
                            <div className='mx-3 my-1' style={{ width: '29rem' }}>
                                <label className='form-label'>UOM</label>
                                <select name="uom" value={formData.uom} onChange={handleChange} className="form-select" style={{ boxShadow: '0px 0px 4px' }}>
                                    <option disabled value="">Select UOM</option>
                                    <option value="Kg">Kgs</option>
                                    <option value="Ton">Bdle</option>
                                    <option value="Litre">Ltr</option>
                                    <option value="Piece">Nos</option>
                                    <option value="Meter">Set</option>
                                    <option value="Pack">Roll</option>
                                    <option value="Pack">Pkt</option>
                                    <option value="Pack">Kit</option>
                                </select>
                            </div>
                        </div>
                        <div className='my-3' style={{ display: 'flex' }}>
                            <div className='mx-3 my-1' style={{ width: '29rem' }}>
                                <label className='form-label'>Invoice Amount</label>
                                <input className='form-control' type='text' placeholder='Invoice Amount' />
                            </div>
                            <div className='mx-3 my-1' style={{ width: '29rem' }}>
                                <label className='form-label'> Remarks (If any)</label>
                                <input className='form-control' type='text' placeholder='Remarks (If any)' />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default GRN;
